import { jsx as _jsx } from "react/jsx-runtime";
import MarkdownBase from './MarkdownBase';
export function Markdown(props) {
    return _jsx(MarkdownBase, { ...props });
}
